import { Checkbox } from 'antd';
import type { CheckboxProps } from 'antd';

export interface DCheckboxProps extends CheckboxProps {}

export const DarwinCheckbox = (props: DCheckboxProps) => {
  return <Checkbox {...props} />;
};
